/**
 * These mirror Meta's carousel card spec and are checked in the browser before upload.
 */

export interface MetaCarouselRatio {
  label: string;
  ratio: number;
  minWidth: number;
  minHeight: number;
}

export const META_CAROUSEL_RATIOS: MetaCarouselRatio[] = [
  { label: '1:1', ratio: 1, minWidth: 500, minHeight: 500 },
  { label: '4:5', ratio: 4 / 5, minWidth: 500, minHeight: 625 },
  { label: '9:16', ratio: 9 / 16, minWidth: 500, minHeight: 888 },
];

export const META_CAROUSEL_RATIO_TOLERANCE = 0.02;

export const META_CAROUSEL_MAX_IMAGE_KB = 30 * 1024;

export const META_CAROUSEL_MAX_VIDEO_SECONDS = 240 * 60;

/**
 * Validates the dimensions of a carousel card media asset against Meta's
 * supported ratios and minimum sizes.
 */
export function metaCarouselDimensionError(
  kind: 'Image' | 'Video',
  width: number,
  height: number,
): string | null {
  if (height === 0) {
    return `${kind} must be 1:1, 4:5 or 9:16!`;
  }

  for (const r of META_CAROUSEL_RATIOS) {
    if (Math.abs(width / height - r.ratio) <= r.ratio * META_CAROUSEL_RATIO_TOLERANCE) {
      if (width < r.minWidth || height < r.minHeight) {
        return `${kind} must be at least 500x500 (1:1), 500x625 (4:5) or 500x888 (9:16)!`;
      }
      return null;
    }
  }

  return `${kind} must be 1:1, 4:5 or 9:16!`;
}
